import { render, staticRenderFns } from "./ChargesForm.vue?vue&type=template&id=c4e4a0f6&"
import script from "./ChargesForm.vue?vue&type=script&lang=js&"
export * from "./ChargesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports